import CheckedSegmentationDetail from "components/ElementSelector/Common/CheckedSegmentationDetail";
import SegmentationDetailImage from "components/ElementSelector/Common/SegmentationDetailImage";
import { Checkbox, InterestName, ShrinkingCol } from "./ElementBlock.style";

import * as React from "react";
import { Col } from "react-grid-system";
import theme from "themes/simple-theme";

interface IProps {
  checked?: boolean;
  isUsageType?: boolean;
  name: string;
  imageUrl?: string;
  onClick: any;
}

const InterestBlock = ({
  checked,
  isUsageType,
  onClick,
  name,
  imageUrl
}: IProps): JSX.Element => (
  <div onClick={onClick} key={name}>
    <Checkbox
      style={{
        backgroundColor: checked ? theme.color.tertiary : theme.color.secondary
      }}
    >
      {checked ? (
        <CheckedSegmentationDetail />
      ) : (
        <Image name={name} isUsageType={isUsageType} imageUrl={imageUrl} />
      )}
      <InterestName fullWidth center noMargin alternate block={false}>
        {name}
      </InterestName>
    </Checkbox>
  </div>
);

const Image = ({ isUsageType, name, imageUrl }) => (
  <>
    {isUsageType ? (
      <SegmentationDetailImage src={`/images/${name.toLowerCase()}-icon.svg`} />
    ) : (
      <SegmentationDetailImage
        src={imageUrl ? imageUrl : `/images/recreational-icon.svg`}
      />
    )}
  </>
);

export default InterestBlock;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/Common/ElementBlock/ElementBlock.tsx